import { Button, Stack } from 'components';
import { useState } from 'react';
import { ClientProfileContentItem } from 'store/clientProfile/clientProfileSlice';

import style from './transcript.module.scss';

type Props = {
  note: ClientProfileContentItem;
};

const Transcript = ({ note }: Props) => {
  const [showTranscript, setShowTranscript] = useState(false);
  const transcript = note.aiScribe?.transcript;

  const html = `<div>
  <p>[AI-Generated Transcript]</p>
  </br>
  ${transcript}
  </div>`;

  const stripHtml = (htmlString: string) => {
    const temp = document.createElement('div');
    temp.innerHTML = htmlString;
    return temp.textContent || temp.innerText || '';
  };

  return (
    <Stack pt="12px" className={style.transcriptContainer} boxSizing="border-box">
      <Stack
        width="100%"
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        boxSizing="border-box"
      >
        <button
          type="button"
          className={style.viewTranscriptButton}
          onClick={() => setShowTranscript(!showTranscript)}
        >
          <span className="material-icons" data-icon data-expanded={showTranscript}>
            expand_more
          </span>
          <span>View Transcript</span>
        </button>
        {note.draft && html && (
          <Stack width="110px" style={{ opacity: showTranscript ? 1 : 0 }}>
            <Button
              customStyleClass={style.copyButton}
              text="Copy"
              type="button"
              handleOnClick={() => {
                navigator.clipboard.writeText(stripHtml(html));
              }}
              icon={
                <span className="material-icons" data-icon>
                  content_copy
                </span>
              }
              theme="transparent"
              size="small"
            />
          </Stack>
        )}
      </Stack>
      {showTranscript && html && (
        <Stack mt="16px">
          <div className={style.transcript} dangerouslySetInnerHTML={{ __html: html }} />
        </Stack>
      )}
    </Stack>
  );
};

export default Transcript;
